export default {
  key: 'aedaroddi',
  basepath: '/lodir/aedaroddi',
  image: {
    src: require('images/lodir/aedaroddi/aedaroddi-yfirlit.jpg'),
    width: 7328,
    height: 5038,
  },
  afangar: [require('./aedaroddi-40-49.js').default],
}
